import React from 'react';
import { renderRoutes } from 'react-router-config';
import { GlobalStyle } from '@app/src/config/style';

interface Props {
  route?:any;
}

export const App: React.FC<Props> = props => {
  return (
    <React.Fragment>
      <GlobalStyle />
      {renderRoutes(props.route.routes)}
    </React.Fragment>
  )
};
